type Props = { active: boolean; verified: boolean };

export function StatusBadge({ active, verified }: Props): React.JSX.Element {
  if (!active) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-ink-100 px-2.5 py-0.5 text-xs font-semibold text-ink-500">
        <span className="inline-block h-[5px] w-[5px] rounded-full bg-ink-300" />
        Deshabilitado
      </span>
    );
  }
  if (!verified) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-700">
        <span className="inline-block h-[5px] w-[5px] rounded-full bg-amber-400" />
        Esperando verificación
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-stage-inscrito-bg px-2.5 py-0.5 text-xs font-semibold text-stage-inscrito-fg">
      <span className="inline-block h-[5px] w-[5px] rounded-full bg-stage-inscrito-fg" />
      Activo
    </span>
  );
}
